import { CoreModule } from './../../core/core.module';
import { HighlightPipe } from './../../core/pipes/highlight.pipe';
import { JobsRoutingModule } from './job-routing.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "src/app/app-routing.module";
import { JobDetailsComponent } from "./components/job-details/job-details.component";
import { JobLeftPanelComponent } from "./components/job-left-panel/job-left-panel.component";
import { JobListComponent } from './components/job-list/job-list.component';
import { JobParentListComponent } from "./components/job-parent-list/job-parent-list.component";
import { JobMainPanelComponent } from "./components/job-main-panel/job-main-panel.component";
import { NgxSpinnerModule } from 'ngx-spinner';
import { ConvergeJobComponent } from './modals/jobDialogs/converge-job/converge-job.component';
import { JobConfirmationDialogComponent } from './modals/jobActions/job-confirmation-dialog/job-confirmation-dialog.component';
import { JobOutputDialogComponent } from './modals/jobActions/job-output-dialog/job-output-dialog.component';
import { JobPriorityDialogComponent } from './modals/jobActions/job-priority-dialog/job-priority-dialog.component';
import { RunJobCommandComponent } from './modals/jobActions/run-job-command/run-job-command.component';
import { AbaqusJobComponent } from './modals/jobDialogs/abaqus-job/abaqus-job.component';
import { CfxJobComponent } from './modals/jobDialogs/cfx-job/cfx-job.component';
import { CommandJobComponent } from './modals/jobDialogs/command-job/command-job.component';
import { FluentJobComponent } from './modals/jobDialogs/fluent-job/fluent-job.component';
import { LsDynaJobComponent } from './modals/jobDialogs/ls-dyna-job/ls-dyna-job.component';
import { MechanicalJobComponent } from './modals/jobDialogs/mechanical-job/mechanical-job.component';
import { StarccmJobComponent } from './modals/jobDialogs/starccm-job/starccm-job.component';
import { StoreExplorerComponent } from './modals/jobActions/store-explorer/store-explorer.component';
import { MscActranComponent } from './modals/jobDialogs/msc-actran/msc-actran.component';
import { OptistructComponent } from './modals/jobDialogs/optistruct/optistruct.component';
import { OptisComponent } from './modals/jobDialogs/optis/optis.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RadiossComponent } from './modals/jobDialogs/radioss/radioss.component';
import { HfssComponent } from './modals/jobDialogs/hfss/hfss.component';
import { NanoFluidXComponent } from './modals/jobDialogs/nano-fluid-x/nano-fluid-x.component';
import { MscNastranJobComponent } from './modals/jobDialogs/msc-nastran-job/msc-nastran-job.component';
import { DynamicJobComponent } from './modals/jobDialogs/dynamic-job/dynamic-job.component';
import { FileUploadModule } from 'ng2-file-upload';
import { JobChartDialogComponent } from './modals/jobActions/job-chart-dialog/job-chart-dialog.component';
import { ManageZipDialogComponent } from './modals/jobActions/manage-zip-dialog/manage-zip-dialog.component';
import { NgChartsModule } from 'ng2-charts';
import { ResizableModule } from '../../core/directive/resizable/resizable.module';
import { FileEditorComponent } from './modals/jobActions/file-editor/file-editor.component';
import { FileAlreadyExistsActionComponent } from './modals/jobActions/file-already-exists-action/file-already-exists-action.component';
import { AngularMaterialModule } from 'src/app/shared/material-module';
import { JobTemplateListComponent } from './components/job-template-list/job-template-list.component';
import { ConfirmDeleteJobTemplateComponent } from './modals/jobActions/confirm-delete-job-template/confirm-delete-job-template.component';
import { UpdateJobTemplateComponent } from './modals/jobActions/update-job-template/update-job-template.component';
import { SharedModule } from '../shared/shared.module';
import { ReorderQueuedJobsComponent } from './modals/jobActions/reorder-queued-jobs/reorder-queued-jobs.component';
import { ImportJobsComponent } from './modals/jobActions/import-jobs/import-jobs.component';
import { SummaryComponent } from './components/summary/summary.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { JobAdvanceViewComponent } from './components/job-advance-view/job-advance-view.component';
import { DynamicPaginationDirective } from 'src/app/core/directive/dynamicPagination/dynamic-pagination.directive';
import { AngularSplitModule } from 'angular-split';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { AimlJobComponent } from './modals/jobDialogs/aiml-job/aiml-job.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MonacoFileEditorComponent } from './modals/jobActions/monaco-file-editor/monaco-file-editor.component';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { JobPartitionDialogComponent } from './modals/jobActions/job-partition-dialog/job-partition-dialog.component';

@NgModule({
  declarations: [
    JobListComponent,
    JobDetailsComponent,
    JobMainPanelComponent,
    JobLeftPanelComponent,
    JobParentListComponent,
    ConvergeJobComponent,
    JobConfirmationDialogComponent,
    JobOutputDialogComponent,
    JobPriorityDialogComponent,
    JobPartitionDialogComponent,
    RunJobCommandComponent,
    AbaqusJobComponent,
    CfxJobComponent,
    CommandJobComponent,
    FluentJobComponent,
    LsDynaJobComponent,
    MechanicalJobComponent,
    StarccmJobComponent,
    StoreExplorerComponent,
    MscActranComponent,
    OptistructComponent,
    OptisComponent,
    RadiossComponent,
    HfssComponent,
    NanoFluidXComponent,
    MscNastranJobComponent,
    DynamicJobComponent,
    JobChartDialogComponent,
    ManageZipDialogComponent,
    FileEditorComponent,
    FileAlreadyExistsActionComponent,
    JobTemplateListComponent,
    ConfirmDeleteJobTemplateComponent,
    UpdateJobTemplateComponent,
    ReorderQueuedJobsComponent,
    ImportJobsComponent,
    SummaryComponent,
    JobAdvanceViewComponent,
    AimlJobComponent,
    MonacoFileEditorComponent
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    NgxPaginationModule,
    JobsRoutingModule,
    NgxSpinnerModule,
    CoreModule,
    NgbModule,
    FileUploadModule,
    NgChartsModule,
    ResizableModule,
    SharedModule,
    NgSelectModule,
    DynamicPaginationDirective,
    AngularSplitModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    DragDropModule,
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MonacoEditorModule.forRoot()
  ], providers: [HighlightPipe, DatePipe]
})
export class JobModule { }
